export const SHOW_IMAGES: Record<string, string> = {
  'Macro Mondays': 'thumb_macro_mondays.png',
  'The Hedging Show': 'thumb_the_hedging_show.png',
  'Inside the Minds': 'thumb_inside_the_minds.png',
  'The Officials European Window': 'thumb_the_officials_european_window.png',
  'The Officials Singapore Window': 'thumb_the_officials_singapore_window.png',
  'The Officials Explain': 'thumb_the_officials_explain.png',
  'Flux Insights': 'thumb_flux_insights.png',
  'Industry And Leadership': 'thumb_industry_and_leadership.png',
  'Trading Corner': 'thumb_trading_corner.png',
  'UK Energy Show': 'thumb_uk_energy_show.png',
  'UK Energy Show Extended': 'thumb_uk_energy_show_extended.png',
  'Book Club': 'thumb_book_club.png',
  'Asia Morning Headlines': 'thumb_asia_morning_headlines.png',
  'Scenario Analysis': 'thumb_scenario_analysis.png',
  'Weather Show': 'thumb_weather_show.png',
};

export const SHOW_COMING_SOON_IMAGES: Record<string, string> = {
  'Macro Mondays': 'thumb_macro_mondays_soon.png',
  'The Hedging Show': 'thumb_the_hedging_show_soon.png',
  'Inside the Minds': 'thumb_inside_the_minds_soon.png',
  'The Officials European Window': 'thumb_the_officials_european_window_soon.png',
  'The Officials Singapore Window': 'thumb_the_officials_singapore_window_soon.png',
  'The Officials Explain': 'thumb_the_officials_explain_soon.png',
  'Flux Insights': 'thumb_flux_insights_soon.png',
  'Industry And Leadership': 'thumb_industry_and_leadership_soon.png',
  'Trading Corner': 'thumb_trading_corner_soon.png',
  'UK Energy Show': 'thumb_uk_energy_show_soon.png',
  'UK Energy Show Extended': 'thumb_uk_energy_show_extended_soon.png',
  'Book Club': 'thumb_book_club_soon.png',
  'Asia Morning Headlines': 'thumb_asia_morning_headlines_soon.png',
  'Scenario Analysis': 'thumb_scenario_analysis_soon.png',
  'Weather Show': 'thumb_weather_show_soon.png',
};

export const CATEGORY_IMAGES: Record<string, string> = {
  'Market Windows': 'thumb_market_windows.png',
  'Macro and Energy': 'thumb_macro_and_energy.png',
  'Energy Sector': 'thumb_energy_sector.png',
  'Explainers and Tutorials': 'thumb_explainers_and_tutorials.png',
  'Leadership and People': 'thumb_leadership_and_people.png',
  'Regional Asia': 'thumb_regional_asia.png',
  'Regional Europe': 'thumb_regional_europe.png',
  'Regional-US': 'thumb_regional-US.png',
  'Regional-Middle East': 'thumb_regional-middle_east.png',
  'Weather and Reports': 'thumb_weather_and_reports.png',
  Officials: 'thumb_officials.png',
  'Flux News': 'thumb_generic_flux_news.png',
};

export const CATEGORY_COMING_SOON_IMAGES: Record<string, string> = {
  'Market Windows': 'thumb_market_windows_soon.png',
  'Macro and Energy': 'thumb_macro_and_energy_soon.png',
  'Energy Sector': 'thumb_energy_sector_soon.png',
  'Explainers and Tutorials': 'thumb_explainers_and_tutorials_soon.png',
  'Leadership and People': 'thumb_leadership_and_people_soon.png',
  'Regional Asia': 'thumb_regional_asia_soon.png',
  'Regional Europe': 'thumb_regional_europe_soon.png',
  'Regional US': 'thumb_regional-US_soon.png',
  'Regional Middle East': 'thumb_regional-middle_east_soon.png',
  'Weather and Reports': 'thumb_weather_and_reports_soon.png',
  Officials: 'thumb_officials_soon.png',
  'Flux News': 'thumb_generic_flux_news_soon.png',
};

export const NUMBER_OF_SHORTS = 24;
export const CARD_WIDTH_VALUES = { xs: 215, sm: 260, md: 260, lg: 300, xl: 355 };
